import { createReducer, on } from '@ngrx/store';
import { MarkdownCheckState } from 'app/state/models/organizations';
import * as MarkdownsActions from '../../actions/organizations/markdowns.actions';
import * as AuthActions from '../../actions/auth.actions';

export const initialState: MarkdownCheckState = {
  markdownCheckResults: []
};

export const markdownsReducer = createReducer(
  initialState,
  
  // Add markdown check results
  on(MarkdownsActions.checkMarkdownAndCreateVersionSuccess, (state, { uploadIntentId, results }) => {
    const filteredResults = state.markdownCheckResults.filter(
      result => result.uploadIntentId !== uploadIntentId
    );
    
    return {
      ...state,
      markdownCheckResults: [
        ...filteredResults,
        { uploadIntentId, results }
      ]
    };
  }),
  
  // Get markdown validation results
  on(MarkdownsActions.getMarkdownValidationResultsSuccess, (state, { uploadIntentId, results }) => {
    const filteredResults = state.markdownCheckResults.filter(
      result => result.uploadIntentId !== uploadIntentId
    );
    
    return {
      ...state,
      markdownCheckResults: [
        ...filteredResults,
        { uploadIntentId, results }
      ]
    };
  }),
  
  // Remove markdown check results when a version is deleted
  on(MarkdownsActions.deleteMarkdownVersionSuccess, (state, { markdown }) => {
    return {
      ...state,
      markdownCheckResults: state.markdownCheckResults.filter(
        result => result.uploadIntentId !== markdown.uploadIntentId
      )
    };
  }),
  
  // Reset markdown check results on logout or clearUserData
  on(AuthActions.logout, AuthActions.clearUserData, () => initialState)
);